import styles from "./ChatUserNode.module.scss";
import { ChatInterfaceUtil } from "./ChatInterfaceUtil";
import React from "react";
import cls from "classnames";
export function ChatUserNode(props) {
  var copy = function copy() {
    ChatInterfaceUtil.copy(props.message);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftCorners
  }), /*#__PURE__*/React.createElement("div", {
    onClick: copy,
    className: styles.messageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.message
  }, props.message)), /*#__PURE__*/React.createElement("div", {
    className: styles.rightCornersBox
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(styles.rgtTopCorners, props.showMask ? "" : styles.showRadiusBottomRgt)
  }), /*#__PURE__*/React.createElement("div", {
    className: cls(styles.chatPubBubbleCorner, props.showMask ? styles.rgtMsgMask : "")
  }))));
}